export default __webpack_public_path__ + "static/media/AndrewDavid@3x.2afd0ea3.png";